<template>
  <div id="hpFf_wrap">
    <div class="hpFt_sec01"> <!-- 섹션 1 : 플렉스1 -->
      <div class="hpFt_leftInfo"> <!-- 상담센터 + 입금계좌 : 플렉스 왼쪽 -->
        <div class="hpft_infoCT"> <!-- 여행상담센터 연락처 및 시간 -->
          <div class="hpft_infoCall"> <!-- 연락처 -->
            여행상담센터
            <p>02-3273-3311</p>
            <p>02-3273-4311</p>
          </div>
          <div class="hpft_infoTime"><!-- 시간 -->
            <div class="hpft_infoTime_Mo">
              <p>상담시간 : 평일 09:30 ~ 18:00</p>
              <p>점심 : 12:30 ~ 13:30 / 토,일,공휴일 휴무</p>
            </div>
            <div class="hpft_infoTime_PC">
              상담시간
              <p>평일 09:30 ~ 18:00</p>
              <p>점심 : 12:30 ~ 13:30 / 토,일,공휴일 휴무</p>
            </div>
            <div class="hpft_infoBtn">
              <button @click="goToCommunity(3)">온라인문의</button>
              <button @click="goToCommunity(5)">단체여행문의</button>
            </div>
          </div>
        </div>
        <div class="hpft_infoBank"> <!-- 입금처 -->
          <div class="hpft_infoBank01"> <!-- 입금게좌안내 예금주 -->
            입금계좌안내
            <p>예금주 : <br> (주)행복을주는사람들 </p>
          </div>
          <div class="hpft_infoBank02">
            <img src="../../../assets/images/etc/wooribank.png" alt="우리은행" />
            <p>1005-303-875864</p>
          </div>
        </div>
      </div>
      <div class="hpFt_rightInfo"><!-- 공지사항 : 플렉스 오른쪽 -->
        <div class="hpft_NoticeTit"><!-- 공지사항 타이틀 박스 -->
          <a href="/Community?communityID=1">공지 &amp; 새소식</a>
          <img src="../../../assets/images/icon/icon_arrowNextBold.png" alt="우측 아이콘" />
        </div>
        <div class="hpft_NoticBox">
          <a
            :href="`/NoticeDetail?notice_ID=${item.notice_ID}`"
            v-for="item in statusData.noticeData"
            :key="item.notice_ID">
            <div>
              <em>N</em>
              <span>[공지]{{ item.notice_title }}</span>
            </div>
            <span class="hpft_NoticBox_data">{{ item.notice_registe }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="hpFt_partnerLink"><!-- 협력체  -->
      <div class="hpFt_partnerLinkIn">
        <swiper :options="statusData.rollingPartnerBanner"
          class="hpFt_partnerLinkInBox">
          <swiper-slide
            v-for="item in statusData.partnerData"
            :key="item.partner_ID">
            <a :href="item.partner_link" target="_blank">
              <img
                :src="item.partner_image"
                :alt="item.partner_name"
              />
            </a>
          </swiper-slide>
        </swiper>
        <p class="partnerLink_swiper_prev" slot="button-prev"/>
        <p class="partnerLink_swiper_next" slot="button-next"/>
      </div>
    </div><!-- 섹션 2 : 지역 로고 슬라이드 -->
    <div class="hpFt_addressWrap"><!-- 섹션 3 : 기존 푸터 내용 -->
      <div class="hpFt_addressLogo"></div> <!-- 로고 / 플렉스 왼쪽-->

      <div class="hpFt_addressBox_right"><!-- 플렉스 오른쪽 -->
        <div class="hpFt_addressLink"><!-- 이용약관 -->
          <ul>
            <li>
              <a href="/CompanyIntroduction">회사소개</a>
            </li>
            <li>
              <a href="/TermsAndPolicies?termsAndPoliciesID=1">이용약관</a>
            </li>
            <li>
              <a href="/TermsAndPolicies?termsAndPoliciesID=2">개인정보취급방침</a>
            </li>
            <li>
              <a href="/TermsAndPolicies?termsAndPoliciesID=3">여행약관</a>
            </li>
            <li>
              <a href="/Community?communityID=3">온라인문의</a>
            </li>
          </ul>
        </div>
        <div class="htFt_addressBox">
          <div class="hpFt_addressBox_Tit">(주)행복을주는사람들</div>
          <div class="hpFt_addressBox_info"><!-- 푸터 내용 작성 -->
            <p>
              <span>(03150) 서울특별시 종로구 삼봉로 81, 425호(수송동, 두산위브파빌리온) <em>(주)행복을주는사람들</em></span>
              <span>대표자 : 배성준</span>
            </p>
            <p>
              <span>전화번호 : 02-3273-3311</span>
              <span>팩스번호 : 02-3273-6311</span>
              <span>이메일 : happy85922@nate.com</span>
            </p>
            <p>
              <span>사업자번호 : 106-86-85922</span>
              <span>법인등록번호 : 110111-4836940</span>
            </p>
            <p>
              <span>통신판매업신고 : 제 2021-서울종로-0952호</span>
              <span>국내·외 관광사업자 등록번호 : 제 2021-000015호</span>
            </p>
            <p>
              <span>개인정보관리책임자 : 배성준</span>
              <span>정보담당자 : 배성준</span>
            </p>
          </div>
          <p class="hpFt_addressBox_copyright">COPYRIGHT(C) 2024 <span>(주)행복을주는사람들.</span> ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import {
  get_partner_use,
  get_notice_top4
} from '../../ETC/Axios.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Footer',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  setup () {
    const goToCommunity = (id) => {
      window.location.href = `/Community?communityID=${id}`
    }
    return {
      goToCommunity,
      statusData: ref({
        partnerData: [],
        noticeData: [],
        rollingPartnerBanner: {
          autoplay: {
            delay: 3200,
            disableOnInteraction: false
          },
          speed: 1000,
          loop: true,
          loopAdditionalSlides: 11,
          slidesPerView: 5,
          spaceBetween: 10,
          navigation: {
            prevEl: '.partnerLink_swiper_prev',
            nextEl: '.partnerLink_swiper_next'
          }
        }
      })
    }
  },
  mounted () {
    get_partner_use().then(result_data => {
      this.statusData.partnerData = result_data
    })
    get_notice_top4().then(result_data => {
      this.statusData.noticeData = result_data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Footer.vue